import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@bufferapp/ui';
import UpgradePath from '../../upgrade-paths/index';

const cardStyle = {
  background: '#fff',
  border: '1px solid #B8B8B8',
  boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.16)',
  borderRadius: '4px',
};

const upgradeCardStyle = {
  height: '326px',
  maxWidth: '860px',
  display: 'flex',
  alignItems: 'center',
};

const cardBgStyle = {
  circles: {
    background:
      'url(https://s3.amazonaws.com/buffer-publish/images/circles-cta-background.svg) no-repeat right center',
  },
  squares: {
    background:
      'url(https://s3.amazonaws.com/buffer-publish/images/squares-cta-background.svg) no-repeat right center',
  },
};

const innerContentStyle = {
  maxWidth: '400px',
  marginLeft: '48px',
};

const headingStyle = {
  color: '#121E66',
  fontWeight: 'bold',
  fontSize: '24px',
  fontFamily: 'Roboto',
  lineHeight: '34px',
  marginBottom: '16px',
  marginTop: 0,
};

const bodyStyle = {
  color: '#121E66',
  fontWeight: 'normal',
  fontSize: '16px',
  fontFamily: 'Roboto',
  lineHeight: '26px',
  marginBottom: '16px',
};

const combinedCardStyle = { ...cardStyle, ...upgradeCardStyle };

const getTrialBtn = onTrialClick => (
  <Button
    label="Start a Free 14-Day Trial of the Business Plan"
    type="primary"
    onClick={onTrialClick}
  />
);

const getUpgradeBtn = cta => (
  <UpgradePath>
    {onUpgradeClick => (
      <Button
        label="Upgrade"
        type="primary"
        onClick={() => {
          onUpgradeClick({ cta });
        }}
      />
    )}
  </UpgradePath>
);

const BusinessTrialOrUpgradeCard = ({
  heading,
  body,
  backgroundImage,
  onStartTrialClick,
  showTrialBtn,
  cta,
}) => (
  <div style={{ ...combinedCardStyle, ...cardBgStyle[backgroundImage] }}>
    <div style={innerContentStyle}>
      <h3 style={headingStyle}>{heading}</h3>
      <p style={bodyStyle}>{body}</p>
      {showTrialBtn ? getTrialBtn(onStartTrialClick) : getUpgradeBtn(cta)}
    </div>
  </div>
);

BusinessTrialOrUpgradeCard.propTypes = {
  heading: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  backgroundImage: PropTypes.oneOf(['circles', 'squares']),
  onStartTrialClick: PropTypes.func.isRequired,
  showTrialBtn: PropTypes.bool,
  cta: PropTypes.string.isRequired,
};

BusinessTrialOrUpgradeCard.defaultProps = {
  backgroundImage: 'circles',
  showTrialBtn: false,
};

export default BusinessTrialOrUpgradeCard;
